<template>
  <div>
    <DashboardHeader title="Manage Talents">
      <v-row class="mt-6 mx-2">
        <v-col :cols="isMobile ? 12 : 3" class="px-4 py-4">
          <v-card elevation="2" min-height="900" class="px-4">
            <v-alert color="warning" class="mt-4" dark>
              Select Talent / Staff
            </v-alert>
            <v-autocomplete
              label="Select Talent"
              v-model="selectedStaff"
              :items="allStaffForSelect"
              @input="getSelectedStaff"
            ></v-autocomplete>

            <v-alert type="success" class="mt-4">
              Add New Talent / Staff
            </v-alert>

            <CreateStaff @staff-created="getNewStaff"></CreateStaff>
          </v-card>
        </v-col>
        <v-col :cols="isMobile ? 12 : 3" class="px-4 py-4">
          <v-card elevation="2" min-height="900">
            <PersonalProfileComponent
              v-if="selectedStaff"
              :profile="selectedStaff"
            ></PersonalProfileComponent>
          </v-card>
        </v-col>
        <v-col :cols="isMobile ? 12 : 5" class="px-4 py-4">
          <v-card elevation="2" min-height="900">
            <TalentsTabs
              v-if="selectedStaff"
              :profile="selectedStaff"
              @talent-updated="getUpdatedTalent"
            ></TalentsTabs>
          </v-card>
        </v-col>
      </v-row>
    </DashboardHeader>
  </div>
</template>

<script>
import staffJs from "@/plugins/staff";
import CreateStaff from "./CreateStaff.vue";
import TalentsTabs from "./TalentsTabs.vue";
import DashboardHeader from "@/components/DashboardHeader.vue";
import PersonalProfileComponent from "@/components/myLibrary/PersonalProfileComponent.vue";

export default {
  components: {
    DashboardHeader,
    CreateStaff,
    PersonalProfileComponent,
    TalentsTabs,
  },
  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    },
  },
  async mounted() {
    this.$store.commit("setScreenWidth", this.$vuetify.breakpoint.width);
    await this.getAllStaff();
  },

  updated() {
    this.$store.commit("setScreenWidth", this.$vuetify.breakpoint.width);
  },
  data: () => ({
    allStaffOriginalObjs: [],
    allStaffForSelect: [],
    selectedStaff: null,
    talents: [],
  }),
  methods: {
    async getAllStaff() {
      const staff = await staffJs.getAllStaff();
      if (staff.length > 0) {
        this.allStaffOriginalObjs = staff;
        this.allStaffForSelect = [];
        staff.forEach((st) => {
          this.allStaffForSelect.push({
            text: `${st.name} [${st.id_number}]`,
            value: st,
          });
        });
      }
    },
    getNewStaff(newStaff) {
      this.allStaffOriginalObjs.unshift(newStaff);
      this.allStaffForSelect.unshift({
        text: `${newStaff.name} [${newStaff.id_number}]`,
        value: newStaff,
      });
    },
    getUpdatedTalent(talentObj) {
      const filt = this.allStaffForSelect.filter((talent) => {
        return talent.id != talentObj.id;
      });
      filt.unshift(talentObj);
      filt.forEach((st) => {
        this.allStaffForSelect.push({
          text: `${st.name} [${st.id_number}]`,
          value: st,
        });
      });
    },
    getSelectedStaff() {
      //console.log(this.selectedStaff);
    },
  },
};
</script>
